export const getPublishedDateFromIso = (iso: string) => {
    var date = new Date(iso)

    return date.toLocaleString("default", {month: "long"}) + ' ' + iso.slice(0, 4)
}